import BatchSummaryMain from "components/Batch/BatchSummaryMain";
import MainLayout from 'layouts/mainLayout'
export default function BatchConfigurationPage() {

  const reports = [
    {
      "fileName": "FEB_2025_TEST file.csv",
      "date": "03/02/2025",
      "fileId": 4225,
      "items": [
        {
          "category": "Company Advance Match",
          "matchCount": 0,
          "noMatchCount": 0,
          "errorCount": 2,
          "totalCount": 10
        },
        {
          "category": "Person to Business Match",
          "matchCount": 0,
          "noMatchCount": 0,
          "errorCount": 0,
          "totalCount": 0
        }
      ]
    },
    {
      "fileName": "Sweden JAN_2025 file.csv",
      "date": "11/01/2025",
      "fileId": 4128,
      "items": [
        {
          "category": "Company Match",
          "matchCount": 8,
          "noMatchCount": 0,
          "errorCount": 2,
          "totalCount": 10
        },
        {
          "category": "Person to Business Match",
          "matchCount": 3,
          "noMatchCount": 5,
          "errorCount": 0,
          "totalCount": 8
        }
      ]
    },
    {
      "fileName": "Scotland SEP_2024.csv",
      "date": "07/09/2024",
      "fileId": 4108,
      "items": [
        {
          "category": "Company Match",
          "matchCount": 0,
          "noMatchCount": 0,
          "errorCount": 10,
          "totalCount": 10
        }
      ]
    },
    {
      "fileName": "Belgium MAY_2024 file.csv",
      "date": "07/05/2024",
      "fileId": 4082,
      "items": [
        {
          "category": "Company Match",
          "matchCount": 0,
          "noMatchCount": 0,
          "errorCount": 5,
          "totalCount": 5
        },
        {
          "category": "Person to Business Match",
          "matchCount": 0,
          "noMatchCount": 0,
          "errorCount": 0,
          "totalCount": 0
        }
      ]
    },
    {
      "fileName": "Norway JUN_2024 file.csv",
      "date": "07/06/2024",
      "fileId": 4081,
      "items": [
        {
          "category": "Company Match",
          "matchCount": 166,
          "noMatchCount": 1,
          "errorCount": 0,
          "totalCount": 167
        },
        {
          "category": "Person to Business Match",
          "matchCount": 3,
          "noMatchCount": 1,
          "errorCount": 0,
          "totalCount": 166
        }
      ]
    }
  ]

  const page = {
    "page": 1,
    "count": 1
  }
  return (
    <MainLayout>

      <BatchSummaryMain
        loading={false}
        reportsData={reports}
        pagination={page}
        loadData={null}
        fromDate={null}
        toDate={null}
        order={"desc"}
        orderBy={"date"}
        onSearch={() => { }}
        onExpand={() => { }}
        onFromDateSelect={() => { }}
        onToDateSelect={() => { }}
        onClearFilter={() => { }}
        onRequestSort={() => { }}
      />
    </MainLayout>
  );
}